import { i18n } from '@/locales';
const lc = 'views.hub_management.';
const hubDetailPageTypeList = [
    // 일반 정보
    'basic-info',
    // 소속 라이더 운행 설정
    'worker-operation-setting',
    // 정산 및 운행설정
    'adjustment-operation-setting',
];
const detailPageComponentTypeList = {
    'basic-info': 'BasicInfo',
    'worker-operation-setting': 'WorkerOperationSetting',
    'adjustment-operation-setting': 'AdjustmentOperationSetting',
};
const hubDetailPageTypeOption = hubDetailPageTypeList.map((type) => {
    const replacedTitle = type.replaceAll('-', '_');
    return ({
        title: i18n.t(`${lc}${replacedTitle}`),
        cardName: detailPageComponentTypeList[type],
        type,
    });
});
export default hubDetailPageTypeOption;
